import { createBrowserRouter } from 'react-router-dom';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { ClientProfile } from './pages/ClientProfile';
import { SelectCategory } from './pages/SelectCategory';
import { NewTreatment } from './pages/NewTreatment';
import { TreatmentDetail } from './pages/TreatmentDetail';
import { NotFound } from './pages/NotFound';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AuthRedirect } from './components/auth/AuthRedirect';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      Component: Login
    },
    {
      path: '/index.html',
      Component: AuthRedirect
    },
    {
      path: '/local-redirect',
      Component: AuthRedirect
    },
    {
      Component: ProtectedRoute,
      children: [
        {
          path: '/dashboard',
          Component: Dashboard
        },
        {
          path: '/client/:clientId',
          Component: ClientProfile
        },
        {
          path: '/client/:clientId/new-treatment',
          Component: SelectCategory
        },
        {
          path: '/client/:clientId/new-treatment/:category',
          Component: NewTreatment
        },
        {
          path: '/client/:clientId/treatment/:treatmentId/edit',
          Component: NewTreatment
        },
        {
          path: '/treatment/:treatmentId',
          Component: TreatmentDetail
        }
      ]
    },
    {
      path: '*',
      Component: NotFound
    }
  ],
  {
    basename: '/app'
  }
);
